import { z } from 'zod'
import type { LanguageCodeType } from '@/constants/search/language-code'

export const languagesSchema = z.array(
  z.object({
    name: z.custom<LanguageCodeType>(),
    weight: z.number(),
  }),
)
